export const env = (key?: string, defaultValue?: string) => {
  if (['undefined', undefined, null, ''].includes(key)) {
    return defaultValue ?? '';
  }

  return key ?? defaultValue ?? '';
};
